export default () => `
  .content-container {
    padding: 10px;
  }
`;
